import { Directive, ElementRef, forwardRef, HostListener, inject, Input, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: 'input[redispatchSplitter]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SplitterDirective),
            multi: true,
        },
    ],
    standalone: false,
})
export class SplitterDirective implements ControlValueAccessor {

    @Input() redispatchSplitter;

    onChange = (_value: any[]) => {
    };
    onTouched = () => {
    };

    private renderer = inject(Renderer2);
    private element = inject(ElementRef);

    @HostListener('input', [
        '$event.target.value',
    ])
    input(value: string) {
        this.onChange(value.split(this.separator).filter(Boolean));
    }

    @HostListener('focusout', [
        '$event',
    ])
    onFocusout(_: FocusEvent) {
        this.onTouched();
    }

    writeValue(value: any[]): void {
        this.onTouched();
        const element = this.element.nativeElement;
        const normalizedValue = value == null ? [] : value;
        this.renderer.setProperty(element, 'value', normalizedValue?.join(this.separator));
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    private get separator(): string {
        return (!!this.redispatchSplitter) ? this.redispatchSplitter : ',';
    }

}
